import { IClassroom } from "../../classrooms/types";
import { getResourceUuid } from "../../utils";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { IScenarioPeriodResource } from "../types/IScenarioPeriodResource";

export interface IScenarioPeriodImportMutationParameters {
    classroom: RelationalValue<IClassroom>;
    file: File;
}

export type IScenarioPeriodImportMutationResult = IScenarioPeriodResource;

export const scenarioPeriodImportMutation: IApiMutationFunction<IScenarioPeriodImportMutationParameters> = ({
    classroom,
    file,
}) => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("classroom", getResourceUuid(classroom));

    return {
        method: "POST",
        url: "/scenario_periods/import",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };
};

export const useScenarioPeriodImportMutation = createApiMutationHook<
    IScenarioPeriodImportMutationParameters,
    IScenarioPeriodImportMutationResult
>(scenarioPeriodImportMutation);
